import { DriversLicenseScannerConstants } from './driversLicenseScanner.constants'
import { IDriversLicenseScannerState } from './driversLicenseScanner.types'

export const initialDriversLicenseScannerState: IDriversLicenseScannerState = {
  libLoaded: false,
  message: null,
  resultValue: '',
  resultItems: [],
  showScanner: false,
  licenseInfo: null,
  licenseKeys: [],
}

export function driversLicenseScannerReducer(
  state: IDriversLicenseScannerState = initialDriversLicenseScannerState,
  action: any
): IDriversLicenseScannerState {
  switch (action.type) {
    case DriversLicenseScannerConstants.SET_LIB_LOADED:
      return { ...state, libLoaded: action.libLoaded }
    case DriversLicenseScannerConstants.APPEND_MESSAGE:
      return { ...state, message: action.message }
    case DriversLicenseScannerConstants.SET_RESULT_VALUE:
      return { ...state, resultValue: action.resultValue }
    case DriversLicenseScannerConstants.SET_RESULT_ITEMS:
      return { ...state, resultItems: action.resultItems }
    case DriversLicenseScannerConstants.SET_SHOW_SCANNER:
      return { ...state, showScanner: action.showScanner }
    case DriversLicenseScannerConstants.SET_LICENSE_INFO:
      return { ...state, licenseInfo: action.licenseInfo }
    case DriversLicenseScannerConstants.SET_DRIVERS_LICENSE_KEYS:
      return { ...state, licenseKeys: action.licenseKeys }
    default:
      return state
  }
}
